// extracted by mini-css-extract-plugin
export default {"overflowEllipsis":"OverflowEllipsis_overflowEllipsis__EDgsZ"};